import React from 'react'
import parse from 'html-react-parser'
import styles from './styles/users.module.css'

const UserInfo = ({ activeUserHeading, activeUserCount }) => (
  <div className={styles.userInfoDiv}>
    <div className={styles.userInfoSubHed}>
      <span className={styles.subHed}>{parse(activeUserHeading)}</span>
    </div>
    <div className={styles.userInfoHed}>
      <h3 className={styles.hed}>{parse(activeUserCount)}</h3>
    </div>
  </div>
)

export default UserInfo
